import React, { useEffect, useState } from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { ProofStrip } from './components/ProofStrip';
import { HowItWorks } from './components/HowItWorks';
import { Results } from './components/Results';
import { Ingredients } from './components/Ingredients';
import { HowToUse } from './components/HowToUse';
import { Comparison } from './components/Comparison';
import { SocialProof } from './components/SocialProof';
import { OfferSection } from './components/OfferSection';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { StickyBuyBox } from './components/StickyBuyBox';
// Editable configuration for the page
const pageConfig = {
  promoText: 'Summer savings: up to 40% off + FREE shipping on all orders!',
  pricing: {
    singlePack: 24.95,
    singlePackOriginal: 34.99,
    twoGetOne: 49.9,
    threeGetTwo: 74.85 // Updated to exactly 3x single pack price
  },
  shipping: {
    freeThreshold: 0,
    deliveryWindow: '' // Removed 2-5 business days
  },
  stats: {
    surveySize: 324,
    surveyDuration: '30 days',
    reliefPercentage: 90,
    adhesionPercentage: 81,
    recommendPercentage: 85
  },
  shopify: {
    variantId: '52168809939271' // Updated to the new Shopify variant ID
  }
};
export function App() {
  const [selectedPack, setSelectedPack] = useState('twoGetOne'); // Changed default to twoGetOne
  const [showStickyBuyBox, setShowStickyBuyBox] = useState(false);
  const [showPromoBar, setShowPromoBar] = useState(true);
  // Handle scroll to show sticky buy box
  useEffect(() => {
    const handleScroll = () => {
      // Get the hero section
      const heroSection = document.getElementById('hero-section');
      if (heroSection) {
        // On mobile, we want to show the buy box after scrolling a certain amount
        // On desktop, we keep the original behavior
        const isMobile = window.innerWidth < 768; // md breakpoint in Tailwind is 768px
        if (isMobile) {
          // Show sticky box after scrolling 300px on mobile
          setShowStickyBuyBox(window.scrollY > 300);
        } else {
          // Original desktop behavior - show when hero section is out of view
          const heroBottom = heroSection.getBoundingClientRect().bottom;
          setShowStickyBuyBox(heroBottom < 0);
        }
      }
    };
    // Call once on mount to check initial position
    handleScroll();
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <div className="font-sans text-[#222] min-h-screen bg-white" data-id="element-0">
      {showPromoBar && <div className="bg-[#0E6B6B] text-white py-2 text-center text-sm relative" data-id="element-1">
          {pageConfig.promoText}
          <button onClick={() => setShowPromoBar(false)} className="absolute right-2 top-1/2 transform -translate-y-1/2 text-white" aria-label="Dismiss promotion" data-id="element-2">
            ✕
          </button>
        </div>}
      <Header data-id="element-3" />
      <main data-id="element-4">
        <Hero id="hero-section" config={pageConfig} selectedPack={selectedPack} onPackSelect={setSelectedPack} data-id="element-5" />
        <ProofStrip data-id="element-6" />
        <HowItWorks data-id="element-7" />
        <Results config={pageConfig} data-id="element-8" />
        <Ingredients data-id="element-9" />
        <HowToUse data-id="element-10" />
        <Comparison data-id="element-11" />
        <SocialProof data-id="element-12" />
        <OfferSection config={pageConfig} selectedPack={selectedPack} onPackSelect={setSelectedPack} data-id="element-13" />
        <Guarantee data-id="element-14" />
        <FAQ data-id="element-15" />
      </main>
      <Footer data-id="element-16" />
      {showStickyBuyBox && <StickyBuyBox config={pageConfig} selectedPack={selectedPack} onPackSelect={setSelectedPack} data-id="element-17" />}
    </div>;
}